var _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventHistoryInactive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5583",
    "data-name": "Group 5583",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.081,
    height: 18.563,
    viewBox: "0 0 24.081 18.563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5247",
    "data-name": "Group 5247",
    transform: "translate(0 2.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3536",
    "data-name": "Path 3536",
    d: "M865.339,568.054h-2.6a2.194,2.194,0,0,1-1.563-.648l-.023-.023a1.2,1.2,0,0,0-.832-.333H853a1,1,0,0,1-1-1V553a1,1,0,0,1,1-1h.5v1H853v13.044h7.321a2.194,2.194,0,0,1,1.563.648l.023.023a1.2,1.2,0,0,0,.832.333h2.6a1.2,1.2,0,0,0,.854-.354,2.223,2.223,0,0,1,1.564-.649h7.321V553h-.5v-1h.5a1,1,0,0,1,1,1v13.044a1,1,0,0,1-1,1h-7.321a1.214,1.214,0,0,0-.853.354A2.2,2.2,0,0,1,865.339,568.054Z",
    transform: "translate(-852 -552)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5248",
    "data-name": "Group 5248",
    transform: "translate(2.007 1.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3537",
    "data-name": "Path 3537",
    d: "M866.536,564.553H864.78l-.15-.2a1.97,1.97,0,0,0-1.605-.8H856V549h2.508v1H857v12.542h6.02a2.933,2.933,0,0,1,2.244,1h.264V552.512A2.332,2.332,0,0,0,863.024,550h-1.505v-1h1.505a3.325,3.325,0,0,1,3.512,3.512Z",
    transform: "translate(-856 -549)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5249",
    "data-name": "Group 5249",
    transform: "translate(11.539 1.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3538",
    "data-name": "Path 3538",
    d: "M876.811,564.553H875V552.512A3.325,3.325,0,0,1,878.512,549h7.024v14.549h-7.024c-1.041,0-1.366.351-1.56.731Zm-.808-1h.218a2.584,2.584,0,0,1,2.291-1h6.02V550h-6.02A2.332,2.332,0,0,0,876,552.512Z",
    transform: "translate(-875 -549)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5250",
    "data-name": "Group 5250",
    transform: "translate(4.014 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3539",
    "data-name": "Path 3539",
    d: "M864.014,554.459l-2.007-1.338L860,554.459V547h4.014Zm-2.007-2.544,1,.669V548H861v4.581Z",
    transform: "translate(-860 -547)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventHistoryInactive);
export default __webpack_public_path__ + "static/media/eventHistory-inactive.b75ed405b51f4d84bbfd822b84d2dd79.svg";
export { ForwardRef as ReactComponent };